import icSettings from 'assets/svg/ic_settings.svg';
import icInventory from 'assets/svg/ic_inventory.svg';
import icWallet from 'assets/svg/ic_wallet.svg';
import icDocument from 'assets/svg/ic_document.svg';
import icIngame from 'assets/svg/ic_ingame.svg';
import Inventory from './Components/Inventory';
import AccountSetting from './Components/AccountSetting';
import Wallet from './Components/Wallet';
import History from './Components/History';
import Ingame from './Components/Ingame';
import { MenuItem } from '../utils/types';
export const menuList = [{
  key: MenuItem.INVENTORY,
  name: 'Inventory',
  icon: icInventory,
  Component: Inventory,
  inDropdownMenu: false
}, {
  key: MenuItem.ACCOUNT_SETTINGS,
  name: 'Account Setting',
  icon: icSettings,
  Component: AccountSetting,
  inDropdownMenu: true
}, {
  key: MenuItem.WALLET,
  name: 'Wallet',
  icon: icWallet,
  Component: Wallet,
  inDropdownMenu: false
}, {
  key: MenuItem.IN_GAME,
  name: 'Ingame',
  icon: icIngame,
  Component: Ingame,
  inDropdownMenu: true,
  children: [{
    key: MenuItem.BATTLE_REWARDS,
    name: 'Battle Rewards',
    Component: Ingame,
    inDropdownMenu: false
  }]
}, {
  key: MenuItem.HISTORY,
  name: 'History',
  icon: icDocument,
  Component: History,
  inDropdownMenu: true
}];